var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-image',{attrs:{"src":_vm.logoImg}},[_c('div',{staticClass:"image-slot",attrs:{"slot":"error"},slot:"error"},[_c('img',{attrs:{"src":_vm.imageUrl,"alt":""}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }